import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  findCarDetails: null,
  selectedCar:null,
  finalHour:null,
  finalTripCost:null
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    addfindCarDetails: (state, action) => {

      state.findCarDetails = action.payload
    },
    addSelectedCar: (state, action) => {

        state.selectedCar = action.payload
      },
      addFinalTripCost: (state, action) => {

        state.finalTripCost = action.payload
      },
      addFinalHour: (state, action) => {

        state.finalHour = action.payload
        state.finalTripCost=parseInt(state.finalHour)*parseInt(state.selectedCar?.baseFare);
      },
      onLogOut: (state) => {
        state.findCarDetails = null
        state.selectedCar = null
        state.finalHour = null
        state.finalTripCost=null
      }
   
  },
});

export const {addfindCarDetails,addSelectedCar,addFinalTripCost,addFinalHour,onLogOut} =
bookingSlice.actions;

export default bookingSlice.reducer;